import { IsEnum, IsInt, IsISO8601, IsNumber, IsOptional, IsString } from 'class-validator';
import { MetaList, UIMetaData } from '../browser.types';
import type { UICustomer } from '../customers/browser.types';
import type { UIProperty } from '../properties/browser.types';
import { Insurance } from '../db/models/Insurance';

export interface UIInsurance {
	id: number;
	status: InsuranceStatus | null;
	expirationDate: Date;
	description: string;
	externalId: string;
	provider?: string;
	oasisContractId?: number;
	oasisContractRiskId?: number;
	damageType: DamageType[] | Array<{ value: DamageType; label: string }>;
	properties: Array<UIProperty>;
	customer: UICustomer;
}

export enum InsuranceStatus {
	Active = 'active',
	Inactive = 'inactive',
	UnderConstruction = 'underConstruction',
	Quit = 'quit'
}

export enum DamageType {
	Fire = 'FIRE',
	Explosion = 'EXPLOSION',
	MainsWater = 'MAINS_WATER',
	ElementaryLoss = 'ELEMENTARY_LOSS',
	GlassBreakage = 'GLASS_BREAKAGE',
	StormDamage = 'STORM_DAMAGE',
	HailDamage = 'HAIL_DAMAGE',
	LightningDamge = 'LIGHTNING_DAMAGE',
	FloodDamage = 'FLOOD_DAMAGE',
	Other = 'OTHER'
}
export class UpdateInsuranceBody {
	@IsOptional()
	@IsInt()
	customerId?: Insurance['customerId'];
	@IsOptional()
	@IsString()
	externalId?: Insurance['externalId'];
	@IsOptional()
	@IsString()
	assfinetId?: Insurance['assfinetId'];
	@IsOptional()
	@IsString()
	description?: Insurance['description'];
	@IsOptional()
	@IsString()
	provider?: Insurance['provider'];
	@IsOptional()
	@IsISO8601()
	expirationDate?: Insurance['expirationDate'];
	@IsOptional()
	@IsEnum(InsuranceStatus)
	status?: InsuranceStatus;
	// TODO: enum validation?
	@IsOptional()
	@IsString()
	damageType?: string;
	@IsOptional()
	@IsNumber(undefined, { each: true })
	properties?: Array<number>;
}

export class CreateInsuranceBody extends UpdateInsuranceBody {}

export interface GetInsurancesResponse extends MetaList<UIInsurance, UIMetaData> {}
